"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "colonno": {
    "197df575": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "skipSearch": false
    }],
    "23856949": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "skipSearch": false
    }],
    "532a1ec0": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "skipSearch": false
    }],
    "6b5c11c1": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "skipSearch": false
    }],
    "bb60f25c": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "skipSearch": false
    }],
    "borgate": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5cc2536": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "skipSearch": false
    }],
    "camanna": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cambrianico": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cima": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2a69ec9": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "skipSearch": false
    }],
    "pianca": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "prati": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "solasco": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0cd1c771": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "526a6740": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "skipSearch": false
    }],
    "corniga": [{
      "hkey": "e9fb2bbb",
      "slug": "colonno",
      "name": "Colonno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;